import { pathOr } from 'ramda'

export const isIntegrationIdentityEnabled = (state: Record<string, any>, integration: string) =>
  pathOr(false, ['embed', 'configuration', 'integrations', 'integrationLookUp', integration], state)
